import React, { useEffect, useState } from "react";
import { FaUser, FaChild,/*  FaMoneyBillWave, */ FaTimes, FaPhone, FaEnvelope, FaBaby, FaClipboardList } from "react-icons/fa"; // Iconos de react-icons
import { motion, AnimatePresence } from "framer-motion"; // Animaciones de framer-motion
import { useUser } from "../../../context/UserContext";
import { getDocumentsFirebase, deleteDocumentFirebase } from "../../../services/data-firebase";
import ConfirmAlert from "../../alertComponent/ConfirmAlert";

const ServiciosPremium = () => {
  const [selectedService, setSelectedService] = useState(null);
  const [collectionForUserId, setCollectionForUserId] = useState(null);
  const { user } = useUser(); // Accede a los datos del usuario desde el contexto



  const [showConfirmAlert, setShowConfirmAlert] = useState(false);

  useEffect(() => { 
    const getAllCitasSubs = async () => {
      try {
        let dataFromFirebase = await getDocumentsFirebase("match-subs");
        // Filtrar los servicios que coincidan con el idFirestore del usuario
        const serviciosFiltrados = dataFromFirebase.filter(
          (servicio) => servicio.idPadre === user.idFirestore
        );
        setCollectionForUserId(serviciosFiltrados);
      } catch (error) {
        console.error(error, "error");
      }
    };
    getAllCitasSubs();
  }, [user]);

  const handleShowDetail = (service) => {
    setSelectedService(service);
  };

  const handleCloseDetail = () => {
    setSelectedService(null);
  };

  const handleDeleteService = async () => {
    setShowConfirmAlert(true);
  };

  const handleConfirmDelete = async (confirmed) => {
    setShowConfirmAlert(false);
    
    if (!confirmed) return; // Si el usuario cancela, no hacemos nada
    
    try {
      await deleteDocumentFirebase("match-subs", selectedService.idFirestore);
      setCollectionForUserId((prev) =>
        prev.filter((service) => service.idFirestore !== selectedService.idFirestore)
      );
      setSelectedService(null);
    } catch (error) {
      console.error("Error deleting service:", error);
    }
  };

  return (
    <div className="p-6">
      {/* Aclaración de servicio premium */}
      {collectionForUserId !== null && collectionForUserId.length !== 0 && (
        <>
          <div className="bg-[#e896ef] p-4 rounded-lg mb-6 ">
            <h2 className="text-xl font-semibold text-white flex items-center gap-2">
              <FaUser className="text-white" /> Servicio Premium
            </h2>
            <p className="text-white">
              Estás utilizando un servicio premium. Gracias por tu suscripción.
            </p>
          </div>

          {/* Lista de servicios */}
          <div className="space-y-4">
            {collectionForUserId?.map((service) => (
              <motion.div
                key={service.idFirestore}
                onClick={() => handleShowDetail(service)}
                className={`p-4 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow border-l-4 border-${service.state ? "blue" : "yellow"}-400  cursor-pointer`}
                whileHover={{ scale: 1.02 }} // Efecto al hacer hover
                whileTap={{ scale: 0.98 }} // Efecto al hacer clic
              >
                <h3 className="text-lg font-medium text-gray-800">{service.nana.name}</h3>

                <h2>Dias</h2>
                <div className="flex flex-wrap gap-2 mt-2">
                  {service.diasServicio?.map((dia, index) => (
                    <span
                      key={index}
                      className="px-3 py-1 bg-pink-100 text-pink-800 text-sm font-medium rounded-full shadow-sm"
                    >
                      {dia}
                    </span>
                  ))}
                </div>

                <div className="mt-2 space-y-2">
                  <p className="text-sm text-gray-600">
                    <strong>Propuesta Económica:</strong> {service.propuestaEconomica}
                  </p>
                  <p className="text-sm text-gray-600">
                    <strong>Tipo de Contratación:</strong> {service.tipoContratacion}
                  </p>
                  <p className="text-sm text-gray-600">
                    <strong>Horario:</strong> {service.tipoHorario}
                  </p>
                  <p className="text-sm text-gray-600">
                    <strong>Tipo de Pago:</strong> {service.tipoPago}
                  </p>
                  <p className="text-sm text-gray-600">
                    <strong>Estado:</strong> {service.state ? "Confirmado" : "Pendiente"}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </>
      )}

    {/* Detalle del servicio (modal) */}
<AnimatePresence>
  {selectedService && (
    <motion.div
      className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center p-4 z-50"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.div
        className="bg-white rounded-xl shadow-2xl p-6 w-full max-w-2xl relative max-h-[90vh] overflow-y-auto"
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 50, opacity: 0 }}
      >
        {/* Close button */}
        <button
          onClick={handleCloseDetail}
          className="absolute top-2 right-0 text-gray-500 hover:text-gray-700 transition p-2 rounded-full hover:bg-gray-100"
          aria-label="Close"
        >
          <FaTimes className="text-xl" />
        </button>

        {/* Header */}
        <div className="flex justify-between items-center mb-6 pb-4 border-b">
          <h2 className="text-2xl font-bold text-gray-800">
            Detalle del Servicio
          </h2>
          <span className={`px-3 py-1 rounded-full text-sm font-medium ${
            selectedService.state 
              ? 'bg-green-100 text-green-800' 
              : 'bg-yellow-100 text-yellow-800'
          }`}>
            {selectedService.state ? "Confirmado" : "Pendiente"}
          </span>
        </div>

        {/* Grid layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Sección Padre */}
          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="text-lg font-semibold text-gray-700 flex items-center gap-2 mb-3">
              <FaUser className="text-blue-500" /> Información del Padre
            </h3>
            <div className="space-y-3">
              <div className="flex items-center gap-4">
              
                <div>
                  <p className="text-xs text-gray-500 uppercase font-medium">Nombre</p>
                  <p className="text-gray-800">{selectedService.padres.name}</p>
                </div>
              </div>
              <div>
                <p className="text-xs text-gray-500 uppercase font-medium">Contacto</p>
                <div className="flex flex-wrap gap-2 mt-1">
                  <a 
                    href={`tel:${selectedService.padres.phone}`}
                    className="flex items-center gap-1 text-blue-600 hover:text-blue-800 text-sm"
                  >
                    <FaPhone  className="text-sm" />
                    {selectedService.padres.phone}
                  </a>
                  <a
                    href={`mailto:${selectedService.padres.email}`}
                    className="flex items-center gap-1 text-blue-600 hover:text-blue-800 text-sm"
                  >
                    <FaEnvelope className="text-sm" />
                    Email
                  </a>
                </div>
              </div>
              <div>
                <p className="text-xs text-gray-500 uppercase font-medium">Dirección</p>
                <p className="text-gray-800">{selectedService.padres.address}</p>
                <p className="text-gray-600 text-sm">{selectedService.padres.neighborhood}</p>
              </div>
            </div>
          </div>

          {/* Sección Niñera */}
          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="text-lg font-semibold text-gray-700 flex items-center gap-2 mb-3">
              <FaChild className="text-green-500" /> Información de la Niñera
            </h3>
            <div className="space-y-3">
              <div className="flex items-center gap-4">
                {/* Nanny Avatar */}
                <img
                  src={selectedService.nana.urlAvatar || "https://via.placeholder.com/100"}
                  alt="Avatar de la Niñera"
                  className="w-16 h-16 rounded-full border border-gray-300"
                />
                <div>
                  <p className="text-xs text-gray-500 uppercase font-medium">Nombre</p>
                  <p className="text-gray-800">{selectedService.nana.name}</p>
                </div>
              </div>
              <div>
                <p className="text-xs text-gray-500 uppercase font-medium">Contacto</p>
                <a 
                  href={`tel:${selectedService.nana.phone}`}
                  className="flex items-center gap-1 text-blue-600 hover:text-blue-800 text-sm"
                >
                  <FaPhone className="text-sm" />
                  {selectedService.nana.phone}
                </a>
              </div>
              <div>
                <p className="text-xs text-gray-500 uppercase font-medium">Zonas de Trabajo</p>
                <div className="flex flex-wrap gap-2 mt-1">
                  {selectedService.nana.barrioZona?.slice(0, 3).map((zona, index) => (
                    <span key={index} className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full">
                      {zona}
                    </span>
                  ))}
                  {selectedService.nana.barrioZona?.length > 3 && (
                    <span className="px-2 py-1 bg-gray-100 text-gray-800 text-xs rounded-full">
                      +{selectedService.nana.barrioZona.length - 3} más
                    </span>
                  )}
                </div>
              </div>
              <div>
                <p className="text-xs text-gray-500 uppercase font-medium">Movilidad</p>
                <p className="text-gray-800 capitalize">{selectedService.nana.mobility}</p>
              </div>
            </div>
          </div>

          {/* Sección Detalles del Servicio */}
          <div className="bg-gray-50 p-4 rounded-lg md:col-span-2">
            <h3 className="text-lg font-semibold text-gray-700 flex items-center gap-2 mb-3">
              <FaClipboardList className="text-purple-500" /> Detalles del Servicio
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <div>
                <p className="text-xs text-gray-500 uppercase font-medium">Días</p>
                <div className="flex flex-wrap gap-1 mt-1">
                  {selectedService.diasServicio?.map((dia, index) => (
                    <span key={index} className="px-2 py-1 bg-purple-100 text-purple-800 text-xs rounded-full">
                      {dia}
                    </span>
                  ))}
                </div>
              </div>
              <div>
                <p className="text-xs text-gray-500 uppercase font-medium">Horario</p>
                <p className="text-gray-800 capitalize">{selectedService.tipoHorario}</p>
              </div>
              <div>
                <p className="text-xs text-gray-500 uppercase font-medium">Contratación</p>
                <p className="text-gray-800 capitalize">{selectedService.tipoContratacion}</p>
              </div>
              <div>
                <p className="text-xs text-gray-500 uppercase font-medium">Tipo de Pago</p>
                <p className="text-gray-800 capitalize">{selectedService.tipoPago}</p>
              </div>
              <div className="md:col-span-2 lg:col-span-4">
                <p className="text-xs text-gray-500 uppercase font-medium">Propuesta Económica</p>
                <p className="text-2xl font-bold text-green-600">
                  ${selectedService.propuestaEconomica}
                </p>
              </div>
            </div>
          </div>

          {/* Sección Detalles de los Niños */}
          {selectedService.detallesNinos && (
            <div className="bg-gray-50 p-4 rounded-lg md:col-span-2">
              <h3 className="text-lg font-semibold text-gray-700 flex items-center gap-2 mb-3">
                <FaBaby className="text-pink-500" /> Detalles de los Niños
              </h3>
              <div className="bg-white p-3 rounded border border-gray-200">
                <p className="text-gray-800 whitespace-pre-line">{selectedService.detallesNinos}</p>
              </div>
            </div>
          )}
        </div>

        {/* Delete button */}
        <div className="mt-8 flex justify-end">
          <button
            onClick={handleDeleteService}
            className="flex items-center gap-2 bg-red-500 hover:bg-red-600 text-white py-2 px-6 rounded-lg transition font-medium"
          >
            <FaTimes /> Eliminar Servicio
          </button>
        </div>
      </motion.div>
    </motion.div>
  )}
</AnimatePresence>
  {/* Componente ConfirmAlert */}
  <ConfirmAlert
        isOpen={showConfirmAlert}
        onClose={() => setShowConfirmAlert(false)}
        onConfirm={handleConfirmDelete}
        message="¿Estás seguro que deseas eliminar este servicio? Esta acción no se puede deshacer."
      />

    </div>
  );
};

export default ServiciosPremium;